export const DEV_AUTH_TOKEN_STORAGE_KEY = "devAuthToken";

function isDevAuthEnabled(): boolean {
  if (process.env.NODE_ENV !== "development") {
    return false;
  }
  if (typeof window === "undefined") {
    return false;
  }

  const hostname = window.location.hostname;
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
}

export function authHeaderFromToken(token: string): string {
  // For local dev/testing we support:
  // - Auth0 JWTs (sent as Bearer)
  // - Service-account tokens (raw Authorization header)
  // - Passing a full header via ?token=Bearer%20...
  if (token.includes(" ")) {
    return token;
  }
  if (token.includes(".")) {
    return `Bearer ${token}`;
  }
  return token;
}

export function initDevAuthHeader(): string | null {
  if (!isDevAuthEnabled()) {
    return null;
  }
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return null;
  }

  try {
    const params = new URLSearchParams(window.location.search);
    const tokenFromQuery = params.get("token");
    if (tokenFromQuery) {
      sessionStorage.setItem(DEV_AUTH_TOKEN_STORAGE_KEY, tokenFromQuery);
    }

    const token = sessionStorage.getItem(DEV_AUTH_TOKEN_STORAGE_KEY);
    return token ? authHeaderFromToken(token) : null;
  } catch {
    return null;
  }
}

export function getDevAuthHeader(): string | null {
  if (!isDevAuthEnabled()) {
    return null;
  }
  if (typeof sessionStorage === "undefined") {
    return null;
  }

  try {
    const token = sessionStorage.getItem(DEV_AUTH_TOKEN_STORAGE_KEY);
    return token ? authHeaderFromToken(token) : null;
  } catch {
    return null;
  }
}
